var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 5,
    fill: "#88D4FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 5,
    stroke: "#88D4FF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6073_287838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 32,
    height: 32
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6073_287838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 19.3334C19.5557 19.3334 18.6113 18.9445 17.8335 18.1667C17.0557 17.3889 16.6668 16.4445 16.6668 15.3334C16.6668 14.2223 17.0557 13.2778 17.8335 12.5C18.6113 11.7223 19.5557 11.3334 20.6668 11.3334C21.7779 11.3334 22.7224 11.7223 23.5002 12.5C24.2779 13.2778 24.6668 14.2223 24.6668 15.3334C24.6668 16.4445 24.2779 17.3889 23.5002 18.1667C22.7224 18.9445 21.7779 19.3334 20.6668 19.3334ZM11.3335 23.3334C10.6002 23.3334 9.97239 23.0723 9.45016 22.55C8.92794 22.0278 8.66683 21.4 8.66683 20.6667V10C8.66683 9.26671 8.92794 8.63893 9.45016 8.11671C9.97239 7.59449 10.6002 7.33337 11.3335 7.33337H30.0002C30.7335 7.33337 31.3613 7.59449 31.8835 8.11671C32.4057 8.63893 32.6668 9.26671 32.6668 10V20.6667C32.6668 21.4 32.4057 22.0278 31.8835 22.55C31.3613 23.0723 30.7335 23.3334 30.0002 23.3334H11.3335ZM14.0002 20.6667H27.3335C27.3335 19.9334 27.5946 19.3056 28.1168 18.7834C28.6391 18.2612 29.2668 18 30.0002 18V12.6667C29.2668 12.6667 28.6391 12.4056 28.1168 11.8834C27.5946 11.3612 27.3335 10.7334 27.3335 10H14.0002C14.0002 10.7334 13.7391 11.3612 13.2168 11.8834C12.6946 12.4056 12.0668 12.6667 11.3335 12.6667V18C12.0668 18 12.6946 18.2612 13.2168 18.7834C13.7391 19.3056 14.0002 19.9334 14.0002 20.6667ZM28.6668 28.6667H6.00016C5.26683 28.6667 4.63905 28.4056 4.11683 27.8834C3.59461 27.3612 3.3335 26.7334 3.3335 26V11.3334H6.00016V26H28.6668V28.6667Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePayroll);
export default __webpack_public_path__ + "static/media/ActivePayroll.75a12476b7aee5bf66ba9e83758cf2b7.svg";
export { ForwardRef as ReactComponent };